import { useEffect, useRef } from 'react';

export function AnimatedLogo({ size = 120 }: { size?: number }) {
  const particleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = particleRef.current;
    if (!el) return;
    for (let i = 0; i < 12; i++) {
      const p = document.createElement('div');
      Object.assign(p.style, {
        position: 'absolute',
        width: '3px', height: '3px',
        background: 'rgba(37,99,235,0.2)',
        borderRadius: '50%',
        left: Math.random() * 100 + '%',
        animation: 'logoDrift ' + (5 + Math.random() * 5) + 's linear infinite',
        animationDelay: Math.random() * 6 + 's',
      });
      el.appendChild(p);
    }
  }, []);

  const s = size;
  const iconS = s * 0.65;
  const barW = iconS * 0.14;
  const rx = iconS * 0.03;
  const gap = iconS * 0.075;

  return (
    <div style={{ position:'relative', display:'flex', flexDirection:'column', alignItems:'center', marginBottom:24 }}>
      <style>{`
        @keyframes logoDrift{0%{transform:translateY(80px);opacity:0}10%{opacity:1}90%{opacity:1}100%{transform:translateY(-80px) translateX(20px);opacity:0}}
        @keyframes logoFloat3d{0%,100%{transform:rotateY(-4deg) rotateX(2deg) translateY(0)}50%{transform:rotateY(4deg) rotateX(-2deg) translateY(-8px)}}
        @keyframes glowPulse{0%,100%{opacity:.8;transform:translate(-50%,-50%) scale(1)}50%{opacity:.2;transform:translate(-50%,-50%) scale(1.06)}}
        @keyframes barGrow{0%{transform:scaleY(0);opacity:0}60%{transform:scaleY(1.08)}100%{transform:scaleY(1);opacity:1}}
        @keyframes greenGlow{0%,100%{filter:drop-shadow(0 0 0px transparent)}50%{filter:drop-shadow(0 0 10px rgba(34,197,94,0.35))}}
        @keyframes bgAppear{from{opacity:0;transform:scale(0.8)}to{opacity:1;transform:scale(1)}}
      `}</style>

      {/* Particles */}
      <div ref={particleRef} style={{ position:'absolute', inset:0, overflow:'hidden', pointerEvents:'none', borderRadius:'50%' }} />

      {/* Glow rings */}
      {[s*1.2, s*1.6, s*2].map((w,i) => (
        <div key={i} style={{
          position:'absolute', top:'50%', left:'50%',
          width:w, height:w, borderRadius:'50%',
          border:'1px solid rgba(37,99,235,' + (0.1-i*0.03) + ')',
          animation:'glowPulse 4s ease-in-out infinite',
          animationDelay: i*1.2+'s',
          transform:'translate(-50%,-50%)',
        }}/>
      ))}

      {/* 3D floating logo */}
      <div style={{ perspective:600 }}>
        <div style={{ animation:'logoFloat3d 6s ease-in-out infinite', transformStyle:'preserve-3d', filter:'drop-shadow(0 16px 32px rgba(37,99,235,0.15))' }}>
          <svg width={iconS} height={iconS} viewBox="0 0 160 160" fill="none">
            <rect style={{ animation:'bgAppear 0.5s ease-out forwards', opacity:0 }} width="160" height="160" rx="38" fill="#2563EB"/>
            <rect style={{ transformOrigin:'bottom', animation:'barGrow 0.8s ease-out 0.3s forwards', transform:'scaleY(0)', opacity:0 }} x="28" y="100" width="22" height="40" rx="5" fill="white" opacity=".4"/>
            <rect style={{ transformOrigin:'bottom', animation:'barGrow 0.8s ease-out 0.5s forwards', transform:'scaleY(0)', opacity:0 }} x="58" y="78" width="22" height="62" rx="5" fill="white" opacity=".6"/>
            <rect style={{ transformOrigin:'bottom', animation:'barGrow 0.8s ease-out 0.7s forwards', transform:'scaleY(0)', opacity:0 }} x="88" y="52" width="22" height="88" rx="5" fill="white" opacity=".85"/>
            <rect style={{ transformOrigin:'bottom', animation:'barGrow 0.8s ease-out 0.9s forwards, greenGlow 3s ease-in-out 2s infinite', transform:'scaleY(0)', opacity:0 }} x="118" y="26" width="22" height="114" rx="5" fill="#22C55E"/>
          </svg>
        </div>
      </div>
    </div>
  );
}
